module.exports = __webpack_public_path__ + "static/media/9.Highlighted Spread.4c7d14d1.jpg";